import { render, staticRenderFns } from "./MerchantNews.vue?vue&type=template&id=e6f29412&scoped=true"
import script from "./MerchantNews.vue?vue&type=script&lang=js"
export * from "./MerchantNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f29412",
  null
  
)

export default component.exports